import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowUpRight, FiZap, FiAlertTriangle } from 'react-icons/fi';
import './CompactUpgradePrompt.css';

/**
 * CompactUpgradePrompt - A small, eye-catching upgrade prompt for tight spaces
 * 
 * @param {Object} props
 * @param {string} props.message - Short message about the upgrade
 * @param {string} props.buttonText - Text for the button (should be very short)
 * @param {string} props.type - Type of limit ('quota' or 'characters')
 * @param {number} props.percentage - Percentage of limit used (0-100)
 * @param {function} props.onActionClick - Custom action when clicked
 */
const CompactUpgradePrompt = ({
  message,
  buttonText,
  type = 'quota',
  percentage = 90,
  onActionClick
}) => {
  const navigate = useNavigate();
  
  // Default action is to navigate to account plans
  const handleClick = onActionClick || (() => navigate('/account?tab=plans'));
  
  // Determine urgency based on percentage
  const getUrgencyClass = () => {
    if (percentage >= 100) return 'maxed';
    if (percentage >= 95) return 'critical';
    if (percentage >= 80) return 'warning';
    return 'normal';
  };

  // Get icon based on urgency level
  const getIcon = () => {
    if (percentage >= 100) {
      return <FiAlertTriangle size={16} />;
    }
    return <FiZap size={16} />;
  };

  return (
    <div className={`compact-upgrade-container ${getUrgencyClass()}`}>
      <div className="compact-upgrade-icon">
        {getIcon()}
      </div>
      <div className="compact-upgrade-content">
        <p className="compact-upgrade-message">{message}</p>
      </div>
      <button 
        className="compact-upgrade-button" 
        onClick={handleClick}
        aria-label={buttonText}
      >
        {buttonText} <FiArrowUpRight size={14} />
      </button>
    </div>
  );
};

export default CompactUpgradePrompt; 